import { opponentBlocksFromHighlights, opponentEmptyNetGoalsFromGoals, opponentGameWinningGoalsFromGoals, opponentGoalsFromGoals, opponentPenaltiesFromPenalties, opponentPenaltyMinutesFromPenalties, opponentPowerPlayGoalsFromGoals, opponentPowerplaysFromPowerplays, opponentSavesFromHighlights, opponentShortHandedGoalsFromGoals, opponentShotsFromHighlights, ourBlocksFromHighlights, ourEmptyNetGoalsFromGoals, ourGameWinningGoalsFromGoals, ourGoalsFromGoals, ourPenaltiesFromPenalties, ourPenaltyMinutesFromPenalties, ourPowerPlayGoalsFromGoals, ourPowerplaysFromPowerplays, ourSavesFromHighlights, ourShortHandedGoalsFromGoals, ourShotsFromHighlights } from './IceHockeyStats';

export const ourIceHockeyResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'Win';
        } if (game.winOrLoss === 'tied') {
            return 'Tied';
        } if (game.winOrLoss === 'loss') {
            return 'Loss';
        }
        return '-';
    }
    return '-';
};

export const ourIceHockeyShortenedResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'W';
        } if (game.winOrLoss === 'tied') {
            return 'T';
        } if (game.winOrLoss === 'loss') {
            return 'L';
        }
        return '-';
    }
    return '-';
};

export const ourGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourGoalsFromGoals(game.goals);
    }
    return 0;
};

export const ourPowerPlayGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPowerPlayGoalsFromGoals(game.goals);
    }
    return 0;
};

export const ourShortHandedGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourShortHandedGoalsFromGoals(game.goals);
    }
    return 0;
};

export const ourGameWinningGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourGameWinningGoalsFromGoals(game.goals);
    }
    return 0;
};

export const ourEmptyNetGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourEmptyNetGoalsFromGoals(game.goals);
    }
    return 0;
};

export const ourShotsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourShotsFromHighlights(game.highlightsPerPeriod);
    }
    return 0;
};

export const ourSavesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourSavesFromHighlights(game.highlightsPerPeriod);
    }
    return 0;
};

export const ourBlocksFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourBlocksFromHighlights(game.highlightsPerPeriod);
    }
    return 0;
};

export const ourPenaltiesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPenaltiesFromPenalties(game.penalties);
    }
    return 0;
};

export const ourPenaltyMinutesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPenaltyMinutesFromPenalties(game.penalties);
    }
    return 0;
};

export const ourPowerplaysFromGame = (game: any) => {
    if (game.status === 'finished') {
        return ourPowerplaysFromPowerplays(game.powerplays);
    }
    return 0;
};

// ---------------------------------------------------------------------------------------------------------
// Get opponent game stats
// ---------------------------------------------------------------------------------------------------------

export const opponentIceHockeyResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'Loss';
        } if (game.winOrLoss === 'tied') {
            return 'Tied';
        } if (game.winOrLoss === 'loss') {
            return 'Win';
        }
        return '-';
    }
    return '-';
};

export const opponentIceHockeyShortenedResultFromGame = (game: any) => {
    if (game.status === 'finished') {
        if (game.winOrLoss === 'win') {
            return 'L';
        } if (game.winOrLoss === 'tied') {
            return 'T';
        } if (game.winOrLoss === 'loss') {
            return 'W';
        }
        return '-';
    }
    return '-';
};

export const opponentGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentGoalsFromGoals(game.goals);
    }
    return 0;
};

export const opponentPowerPlayGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPowerPlayGoalsFromGoals(game.goals);
    }
    return 0;
};

export const opponentShortHandedGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentShortHandedGoalsFromGoals(game.goals);
    }
    return 0;
};

export const opponentGameWinningGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentGameWinningGoalsFromGoals(game.goals);
    }
    return 0;
};

export const opponentEmptyNetGoalsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentEmptyNetGoalsFromGoals(game.goals);
    }
    return 0;
};

export const opponentShotsFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentShotsFromHighlights(game.highlightsPerPeriod);
    }
    return 0;
};

export const opponentSavesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentSavesFromHighlights(game.highlightsPerPeriod);
    }
    return 0;
};

export const opponentBlocksFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentBlocksFromHighlights(game.highlightsPerPeriod);
    }
    return 0;
};

export const opponentPenaltiesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPenaltiesFromPenalties(game.penalties);
    }
    return 0;
};

export const opponentPenaltyMinutesFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPenaltyMinutesFromPenalties(game.penalties);
    }
    return 0;
};

export const opponentPowerplaysFromGame = (game: any) => {
    if (game.status === 'finished') {
        return opponentPowerplaysFromPowerplays(game.powerplays);
    }
    return 0;
};
